import { Block } from '@xprog/prensa'
import React from 'react'

import { DotsBackgroundProps } from './DotsBackground.types'

export const DotsBackground: React.FC<DotsBackgroundProps> = ({ css, children, height }) => {
  return (
    <Block
      css={{
        ...css, 
        background: 'transparent',
        backgroundImage: 'radial-gradient(#E6E6E6 0.5px, transparent 0px)',
        backgroundSize: '3px 3px',
        backgroundPosition: '0 0, 3px 3px',
        height: height,
        width: '100%'
      }}
    >
      {children}
    </Block>
  )
}

DotsBackground.defaultProps = {
  height: '100%'
}